/**
 * The Arcadia controlled user actions for risk.
 *
 * The values within this enum match the Arcadia ontology labels of type "RiskAction".
 */
export enum RiskAction {
  Confirm = 'RiskConfirm',
  Deny = 'RiskDeny',
  NoAction = 'RiskNoAction',
}

export const riskActionPrefix = 'Risk';
